module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1176.d003bd58.png";